// Canonical brand links and helpers used across the monorepo.
export const BRAND_LINKS = {
    discord: 'https://discord.gg/rfFTVAqHwH',
    supportEmail: 'poppy@airheadgames.com',
    twitchDirectory: 'https://www.twitch.tv/directory/category/airhead-games',
    youtube: 'https://www.youtube.com/@airhead-games',
    x: 'https://x.com/airhead_games',
    instagram: 'https://www.instagram.com/poppy_airhead_games/',
    tiktok: 'https://www.tiktok.com/@poppy_airhead_games',
};
export const buildSupportMailto = (subject) => {
    const base = `mailto:${BRAND_LINKS.supportEmail}`;
    return subject ? `${base}?subject=${encodeURIComponent(subject)}` : base;
};
//# sourceMappingURL=brandLinks.js.map